import contacto from "./contacto";
import newsletter from "./newsletter";
import puntero from "./puntero";
import columnas from "./columnas";
import productoUnico from "./producto_unico";
import instagram from "./instagram";
import dondeEncontrar from "./donde-encontrar";
import productos from "./productos";
var bloques = function (dataLayer) {
    contacto(dataLayer);
    newsletter(dataLayer);
    puntero();
    columnas();
    productoUnico();
    instagram();
    dondeEncontrar();
    productos();
};
export default bloques;
